import { AxiosError } from "axios";
import ContactServer from "../../server/contact";
import { ContactInput } from "../../dtos/contact/input";
import Service, {
  ServiceCreator,
  ServiceDeleter,
  ServiceReader,
  ServiceUpdater,
} from "..";

class ContactServiceReader extends ServiceReader {}
class ContactServiceCreator extends ServiceCreator {
  constructor(protected api: ContactServer) {
    super();
  }

  public async message(
    name: string,
    email: string,
    title: string,
    message: string
  ): Promise<string | null> {
    try {
      const response = await this.api.post(
        new ContactInput(name, email, title, message)
      );

      if (response.status! / 100 === 2) return null;
      return `Error ${response.status!}: ${response.data!}`;
    } catch (error) {
      console.error(error);
      if (error instanceof AxiosError)
        return (
          "Error " +
          (error.response !== undefined
            ? error.response.status
            : error.status) +
          ": " +
          (error.response
            ? error.response.data
            : error.code
            ? error.code
            : "AXIOS_ERR")
        );
      throw error;
    }
  }
}
class ContactServiceUpdater extends ServiceUpdater {}
class ContactServiceDeleter extends ServiceDeleter {}

export default class ContactService extends Service {
  constructor() {
    super(new ContactServer());
  }

  public get read(): ContactServiceReader {
    return new ContactServiceReader();
  }
  public get create(): ContactServiceCreator {
    return new ContactServiceCreator(this.api as ContactServer);
  }
  public get update(): ContactServiceUpdater {
    return new ContactServiceUpdater();
  }
  public get delete(): ContactServiceDeleter {
    return new ContactServiceDeleter();
  }
}
